// Wizard de primer arranque (Parte 8): crea la organización + usuario admin.
import type { JSX } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ApiError } from "../lib/api.ts";
import { Button, Card, Field, Input, Select } from "../components/ui.tsx";
import { toast } from "../components/toast.tsx";

const TIMEZONES = ["America/Bogota", "America/Mexico_City", "America/Lima", "America/Santiago", "America/Buenos_Aires", "UTC"];

export function Setup(): JSX.Element {
  const navigate = useNavigate();
  const [orgName, setOrgName] = useState("");
  const [timezone, setTimezone] = useState("America/Bogota");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = (e: React.FormEvent): void => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("La contraseña debe tener al menos 8 caracteres."); return; }
    setBusy(true);
    api.post("/setup", {
      organization: { name: orgName, timezone },
      admin: { firstName, lastName, email, password },
    })
      .then(() => {
        toast.success("Organización creada. Inicia sesión.");
        navigate("/login", { replace: true });
      })
      .catch((err: unknown) => setError(err instanceof ApiError ? err.message : "No se pudo completar la configuración."))
      .finally(() => setBusy(false));
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-primary-50 to-white p-4">
      <Card className="w-full max-w-md p-8">
        <h1 className="text-lg font-semibold text-ink">Configuración inicial</h1>
        <p className="text-sm text-ink-secondary mb-6">Crea tu organización y el primer usuario administrador.</p>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Nombre de la organización" required>
            <Input value={orgName} onChange={(e) => setOrgName(e.target.value)} required autoFocus />
          </Field>
          <Field label="Zona horaria" required>
            <Select value={timezone} onChange={(e) => setTimezone(e.target.value)}>
              {TIMEZONES.map((tz) => <option key={tz} value={tz}>{tz}</option>)}
            </Select>
          </Field>
          <div className="border-t border-line pt-4">
            <h2 className="text-xs font-semibold text-ink-muted uppercase tracking-wide mb-3">Administrador</h2>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Nombre" required><Input value={firstName} onChange={(e) => setFirstName(e.target.value)} required /></Field>
              <Field label="Apellido" required><Input value={lastName} onChange={(e) => setLastName(e.target.value)} required /></Field>
            </div>
            <div className="mt-3 space-y-3">
              <Field label="Correo" required><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></Field>
              <Field label="Contraseña" required {...(error ? { error } : {})} hint="Mínimo 8 caracteres.">
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
              </Field>
            </div>
          </div>
          <Button type="submit" variant="primary" className="w-full" disabled={busy}>
            {busy ? "Creando…" : "Crear organización"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
